// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../css/colors.css'","darkOrange":"#D8630F","about":"AboutPage_about__1hGB6"};